<template>
  <div class="table-item1">
    <div class="card-title">
      <svg-icon icon-class="list-title-left" class="title-icon" />
      <span>
        {{ list.title || "-" }}
      </span>
      <svg-icon icon-class="list-title-right" class="title-icon" />
    </div>
    <div class="table-header" v-if="list.data && list.data.length">
      <div class="table-header-col">排名</div>
      <div class="table-header-col">门店名称/大区</div>
      <div class="table-header-col">{{ list.targetName || "-" }}</div>
    </div>
    <div class="table-body" v-if="list.data && list.data.length">
      <div
        class="table-body-item"
        v-for="(item, index) in list.data || []"
        :key="index"
        @click.stop="openPage(item)"
      >
        <div class="table-body-item-col">
          <span :class="['ranking', `ranking${index + 1}`]">{{
            index + 1
          }}</span>
        </div>
        <div class="table-body-item-col">
          <BaseImage
            :src="item.dealerAuthorAvatar || ''"
            :default-image="defaultAvatarImg"
            width="48px"
            height="48px"
            fit="cover"
            round
          />
          <div class="info-right">
            <span>{{ item.dealerName || "-" }}</span>
            <span>{{ item.regionName || "-" }}</span>
          </div>
        </div>
        <div class="table-body-item-col">
          {{ item[list.targetKey] | changeNumNoRound }}
        </div>
      </div>
    </div>
    <div class="empty-box" v-else>
      <Empty title="暂无数据" />
    </div>
  </div>
</template>

<script>
import defaultAvatarImg from "@/assets/default/default1-1.png";
import BaseImage from "@/components/BaseImage";
import Empty from "@/components/Empty/Empty";

export default {
  name: "TableItem1",
  components: {
    BaseImage,
    Empty,
  },
  props: {
    list: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      defaultAvatarImg
    };
  },
  computed: {},
  watch: {},
  methods: {
    openPage(val) {
      const route = this.$router.resolve({
        path: this.list.routePath,
        query: {
          platform: val.platform || 'douyin',
          id: val.dealerId
        }
      });

      window.open(route.href);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_handle.scss";
.table-item1 {
  width: 100%;
  .card-title {
    width: 100%;
    height: 72px;
    background: url("../../../../assets/live_images/list-title-bc.png")
        no-repeat right 0,
      linear-gradient(90deg, #ffe674 0%, #ffc840 100%);
    background-size: contain;
    padding-left: 30px;
    border-radius: 16px 16px 0 0;
    display: flex;
    align-items: center;
    > span {
      font-size: 24px;
      font-weight: bold;
      color: #845303;
      line-height: 32px;
    }
    .title-icon {
      font-size: 34px;
    }
  }
  .table-header {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.88);
    background: #242832;
    > div:nth-child(1) {
      width: 60px;
      text-align: center;
    }
    > div:nth-child(2) {
      width: calc(100% - 230px);
      text-align: left;
      padding-left: 6px;
    }
    > div:nth-child(3) {
      width: 170px;
      text-align: center;
      padding-right: 20px;
    }
  }
  .table-body {
    width: 100%;
    height: calc(100vh - 382px);
    border-radius: 0 0 16px 16px;
    overflow-y: auto;
    &-item {
      height: 72px;
      width: 100%;
      border-bottom: 1px solid #3c4252;
      display: flex;
      align-items: center;
      cursor: pointer;

      &:last-child {
        border: none;
      }
      &-col:nth-child(1) {
        width: 60px;
        text-align: center;
      }
      &-col:nth-child(2) {
        width: calc(100% - 230px);
        display: flex;
        align-items: center;
        .info-right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 8px;
          width: calc(100% - 56px);
          > span:first-child {
            width: 100%;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.88);
            line-height: 22px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
          > span:last-child {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.55);
            line-height: 20px;
            margin-top: 4px;
          }
        }
      }
      &-col:nth-child(3) {
        width: 170px;
        text-align: center;
        padding-right: 20px;
        font-size: 14px;
        font-weight: bold;
        color: #ffcc55;
      }

      &:hover {
        background: #20232C;
      }
    }
  }
  .empty-box {
    background: #2b2f3b;
    height: calc(100vh - 338px);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 16px 16px;
  }
}
.ranking {
  width: 24px;
  height: 24px;
  display: inline-block;
  background: rgba(255, 255, 255, 0.12);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 24px;
  border-radius: 50%;
  text-align: center;
  &.ranking1,
  &.ranking2,
  &.ranking3 {
    background: rgba(255, 204, 85, 0.12);
    color: #ffcc55;
    font-weight: bold;
  }
}
</style>
